import React from 'react';
import withDashedBorder from './withDashedBorder';

import { ShareLinkText } from './style';

const ShareLink = ({ link }) => <ShareLinkText>{link}</ShareLinkText>;

export default withDashedBorder(ShareLink, 'copy');
